export const DONT_KNOW_GOTHRA_VALUE = 0;
export const DONT_KNOW_GOTHRA_LABEL = "Don't Know";

export const isDontKnowGothra = (value) => {
  const raw = value && typeof value === "object" && !Array.isArray(value) ? value.value : value;
  const flat = Array.isArray(raw) ? raw[0] : raw;
  return String(flat) === String(DONT_KNOW_GOTHRA_VALUE);
};

/**
 * Builds the Gothra select options from the API list, pinning "Don't Know" first.
 * The API returns entries shaped as { "<id>": "<name>" }.
 */
export const buildGothraOptions = (list, { numericValue = false } = {}) => {
  const options = (Array.isArray(list) ? list : []).map((entry) => ({
    label: Object.values(entry),
    value: numericValue ? parseInt(Object.keys(entry)[0], 10) : Object.keys(entry),
  }));

  return [
    {
      label: DONT_KNOW_GOTHRA_LABEL,
      value: numericValue ? DONT_KNOW_GOTHRA_VALUE : [String(DONT_KNOW_GOTHRA_VALUE)],
    },
    ...options,
  ];
};

/** Value to POST for a Gothra select, keeping "Don't Know" distinct from "unanswered". */
export const gothraPayloadValue = (selected) => {
  if (selected === null || selected === undefined || selected === "") return "";
  const raw = typeof selected === "object" && !Array.isArray(selected) ? selected.value : selected;
  const flat = Array.isArray(raw) ? raw[0] : raw;
  return flat === null || flat === undefined ? "" : String(flat);
};

/** Rebuilds the selected option for edit forms, so a saved "Don't Know" shows its label. */
export const resolveGothraSelection = (rawValue, name, { numericValue = false } = {}) => {
  if (rawValue === null || rawValue === undefined || rawValue === "") return null;
  if (isDontKnowGothra(rawValue)) {
    return {
      label: DONT_KNOW_GOTHRA_LABEL,
      value: numericValue ? DONT_KNOW_GOTHRA_VALUE : [String(DONT_KNOW_GOTHRA_VALUE)],
    };
  }
  return {
    label: name,
    value: numericValue ? parseInt(rawValue, 10) : rawValue,
  };
};
